export default __webpack_public_path__ + "static/media/Shot_17.0000.6e0b6659.png";